import { type MapRef, useMap as useReactGLMap } from 'react-map-gl';
import { mapId as defaultMapId } from '../utils/constants';

export default function useMap(mapId?: string): MapRef | undefined {
  const { [mapId ?? defaultMapId]: map } = useReactGLMap();

  return map;
}
